const defaultTheme = {
    fontMain: "'Noto Sans JP', sans-serif",
    fontTitle: "'Noto Serif', serif",
    primaryColor: '#519bdb',
    secondaryColor: '#2b2b2b',
  }
  
  export default defaultTheme
  